// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-input-datetime__card .v-picker{border-radius:0!important}.e-input-datetime__card .v-picker__title{height:88px}", ""]);
// Exports
module.exports = exports;
